import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';

const useAllRelationUserBookIdsByBooks = (bookIds: string[] | undefined) : string[] => {
  const relationUserBookDb = useSelector((state: RootState) => state.relationUserBookDb);
  let ids: string[] = []; 
  bookIds?.forEach(bookId => {
    const additionalIds = Object.keys(relationUserBookDb.relationUserBooks).filter(
      id => relationUserBookDb.relationUserBooks[id].bookId === bookId);
    ids.push(...additionalIds);
  });

  return ids;
}

export default useAllRelationUserBookIdsByBooks;
